import {
  actionCard, openModal, tableController, tablePageController, translate,
} from 'magner';
import { suggestionsRead } from 'features/profile/safety/suggestions/requests';
import { ISuggestion } from 'features/profile/safety/suggestions/types';
import suggestionsFilters from 'features/profile/safety/suggestions/filters';
import SuggestionDetail from 'features/profile/safety/suggestions/card.vue';
import { formatDate } from '~/utils/format-date';

const suggestionsConfig = tablePageController<ISuggestion>({
  header: {
    title: translate('gaz.safety.table.title'),
    actions: [],
    tabs: [
      {
        label: translate('gaz.safety.tabs.suggestions'),
        link: { name: 'suggestions' },
        active: true,
      },
      {
        label: translate('gaz.safety.tabs.breaking'),
        link: { name: 'breaking' },
        active: false,
      },
    ],
  },
  request: suggestionsRead,
  table: tableController<ISuggestion>({
    tableLayout: 'auto',
    scrollbarAlwaysOn: true,
    emptyText: translate('gaz.safety.table.not_found'),
    columns: [{
      prop: 'fio',
      label: translate('gaz.safety.table.fio'),
      className: 'suggestions-fio-cell',
      width: 150,
      fixed: 'left',
    }, {
      prop: 'email',
      label: translate('gaz.safety.table.email'),
      width: 250,
    }, {
      prop: 'organization',
      label: translate('gaz.safety.table.organization'),
      width: 200,
    }, {
      prop: 'regulation_act',
      label: translate('gaz.safety.table.regulation_act'),
      width: 300,
    }, {
      prop: 'point',
      label: translate('gaz.safety.table.point'),
      width: 250,
    }, {
      prop: 'text',
      label: translate('gaz.safety.table.text'),
      minWidth: 300,
      view: {
        type: 'text',
        formatter: (_, row) => (row.text.length > 100 ? `${row.text.substring(0, 100)}...` : row.text),
      },
    }, {
      prop: 'createdAt',
      label: translate('gaz.safety.table.createdAt'),
      view: {
        type: 'text',
        formatter: (_, row) => formatDate(row.createdAt),
      },
      width: 160,
    }, {
      prop: 'id',
      label: translate('gaz.safety.table.action_more'),
      width: 200,
      view: {
        type: 'actions',
        actions: [
          {
            type: 'action',
            action: actionCard<any>(async (data) => {
              try {
                await openModal<any>({
                  type: 'custom',
                  handleBeforeClose: false,
                  component: () => SuggestionDetail,
                  props: {
                    suggestion: data.data.row,
                  },
                });
                return false;
              } catch (e) {
                return false;
              }
            }),
            props: {
              text: translate('gaz.safety.table.action_more'),
              type: 'primary',
              plain: true,
            },
          },
        ],
      },
    }],
  }),
  filters: suggestionsFilters,
});

export default suggestionsConfig;
